<template>
  <div>
    <section class="py-5 products-section">
      <div class="container">
        <div class="">
          <h3 class="text-center py-4 text-primary fw-bold">
            Product Of Our Trainings
          </h3>
          <swiper
            :spaceBetween="25"
            :autoplay="{
              delay: 2500,
              disableOnInteraction: false,
            }"
            :pagination="{
              clickable: true,
            }"
            :breakpoints="{
              '640': {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              '768': {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              '1024': {
                slidesPerView: 3,
                spaceBetween: 50,
              },
            }"
            :navigation="true"
            :modules="modules"
          >
            <swiper-slide v-for="product in products" :key="product.id" :class="{'larger-slide': product.id === 2 || product.id === 4 || product.id === 6}">
              <div class="rounded p-3 bg-white">
                <div class="image-box">
                  <img
                    :src="
                      require(`../../assets/Images/home/${product.image_src}`)
                    "
                    class="object-fit-cover product-img"
                    alt=""
                  />
                  <h5 class="text-center pt-3 text-primary">
                    {{ product.name }}
                  </h5>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>
  </div>
</template>
  
  <script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.min.css";
import { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/css/navigation";
export default {
  name: "Arduino",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      products: [
        {
          id: 1,
          image_src: "kompletecare-cover.png",
          name: "KompleteCare website",
        },
        { id: 2, image_src: "eketnse-cover.jpg", name: "Eket NSE website" },
        {
          id: 3,
          image_src: "craftzone-cover.png",
          name: "Craftzone Mobile Application",
        },
        {
          id: 4,
          image_src: "kompletecare-cover.png",
          name: "KompleteCare website",
        },
        { id: 5, image_src: "eketnse-cover.jpg", name: "Eket NSE website" },
        {
          id: 6,
          image_src: "craftzone-cover.png",
          name: "Craftzone Mobile Application",
        },
      ],
    };
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>
  
  <style scoped>
.products-section {
  background: #d8e2f3;
}
.learn-slider {
  width: 70% !important;
  margin: 0 auto;
}

.learn-image {
  height: 400px;
}

.product-img {
  height: 420px;
}

/* .swiper-button-next,
.swiper-button-prev {
  color: #ffffff;
  font-size: 30px;
  z-index: 900;
  color: blue !important;
}

.swiper-button-next {
  right: 0px;
}

.swiper-button-prev {
  left: 0px;
} */

.showcase {
  height: 360px;
}

.swiper-container {
  width: 100%;
  height: 300px;
}

.swiper-slide {
  display: block;
}

.image-box {
  margin: 10px;
}

.swiper-slide img {
  display: block;
  width: 100%;
}

.swiper {
  padding: 0 35px;
}

.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50% !important;
  width: 27px;
  height: 44px;
  margin-top: -22px !important;
  z-index: 1000;
  cursor: pointer;
  /* background-size: 27px 44px;
  background-position: center;
  background-repeat: no-repeat; */
}

.swiper-button-prev {
  left: 0px;
  /* background-image: url('../../assets/Images/home/arrow-left.png'); */
}

.swiper-button-next {
  right: 0px;
  /* background-image: url('../../assets/Images/home/arrow-right.png'); */
}

@media (max-width: 769px) {
  .products-section h5 {
    font-size: 18px;
  }
}
</style>
  